/**
 * ngApp定义
 */

define('app',['angular', 'angularLocaleZh','uiRouter', 'ngDialog', 'ngFileUpload','uiSelect','angularSanitize','auiBasic','auiService'], function (angular) {
    return angular.module('MemberCenter', ['aui','ui.router', 'ui.select']);
});

